/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ReportsOverviewEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const reportsOverviewEntrypoint: EntryPoint<ReportsOverviewEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<ReportsOverviewEntrypointComponent>(
			/* webpackChunkName: "async-next-gen-reports-overview-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
